import styles from '../MultiPage.module.scss'
import { useUserContext } from '@logic/contexts/AppStore/UserContext.tsx'
import { usePolicyContext } from '@logic/contexts/AppStore/AbacContext.tsx'
import { UserF } from '@src/logic/contexts/Users/UsersFrontend.type'
import { mapRoleToReadableRole } from '@src/utils/mapRoleToReadableRole.ts'
import { cn } from '@src/utils/cn.ts'
import modalStyles from '@components/modal/modal.module.scss'
import { useModal } from '@logic/contexts/Modal/ModalContext.tsx'
import { LxTooltip } from '@src/components/tooltip/tooltip'
import { USER_STATE } from '@src/utils/constants'
import LxCancelButton from '@src/components/cancelButton/LxCancelButton'
import LxSaveButton from '@src/components/saveButton/LxSaveButton'
import { UserEdit } from './Show/CreateOrEdit/UserEdit'
import { Dialog } from '@mui/material'

interface UserInfoProps {
  user: UserF
  onUpdated?: () => void
}

const UserInfo: React.FC<UserInfoProps> = ({ user, onUpdated }) => {
  const { hideModal, showModal } = useModal()

  const { currentUser } = useUserContext() as any
  const { canPerformAction } = usePolicyContext()

  const canEditUser = canPerformAction(currentUser, { type: 'User' }, 'edit')

  return (
    <Dialog open role='dialog' aria-labelledby='create-user-dialog-title' maxWidth='sm' fullWidth aria-label='User Info'>
      <div className={modalStyles.dialogHeader}>
        <h3>{user.fullName}</h3>
      </div>
      <div className={modalStyles.dialogContent}>
        <div className={styles.infoRow}>
          <strong>First Name:</strong>
          <span>{user.firstName}</span>
        </div>
        <div className={styles.infoRow}>
          <strong>Last Name:</strong>
          <span>{user.lastName}</span>
        </div>
        <div className={styles.infoRow}>
          <strong>Email:</strong>
          <span>{user.primaryEmail}</span>
        </div>
        <div className={styles.infoRow}>
          <strong>Title:</strong>
          <span>{user.jobTitle}</span>
        </div>
        <div className={styles.infoRow}>
          <strong>Role:</strong>
          <span>{mapRoleToReadableRole(user.userRole)}</span>
        </div>
      </div>
      <div className={cn(modalStyles.dialogActions, modalStyles.actionsFullWidth)}>
        <LxCancelButton onCancel={hideModal} label='Close' classNames='lxActionButton,lxActionButtonDefaultSize' />

        {canEditUser &&
          (user.state !== USER_STATE.ACTIVE ? (
            <LxTooltip tooltipText={'User is not active and cannot be edited'}>
              <span>
                <LxSaveButton disabled={true} onSubmit={hideModal} label='Edit User Info' classNames='lxActionButton,lxActionButtonFilled,lxActionButtonDefaultSize' />
              </span>
            </LxTooltip>
          ) : (
            <LxSaveButton
              label='Edit User Info'
              classNames='lxActionButton,lxActionButtonFilled,lxActionButtonDefaultSize'
              onSubmit={() =>
                showModal(
                  <UserEdit
                    user={user}
                    onUpdated={() => {
                      onUpdated?.() // refresh AccountsList
                      hideModal() // close this AccountInfo dialog
                    }}
                  />
                )
              }
            />
          ))}
      </div>
    </Dialog>
  )
}

export default UserInfo
